import React from 'react';

import classNames from 'classnames';

import { UI_SEARCH_TOP_KEYWORDS_NAMESPACE as namespace } from '../../constants';
import { withComponentHandler } from '../../hocs/with-component-handler';
import topKeywordsPropTypes from './propTypes';

/**
 * @typedef {Object} Keyword
 * @property {string} label - The text to display for the keyword
 * @property {string} url - The URL to navigate to when the keyword is clicked
 */

/**
 * @typedef {Object} TopKeywordsProps
 * @property {string} title - The title to display above the keywords list
 * @property {Array<Keyword>} keywords - Array of keyword objects to display
 * @property {string} [className] - Optional CSS class name to add to the component
 */

/**
 * Renders a list of top keywords with their associated links
 * @param {TopKeywordsProps} props - The component props
 * @returns {JSX.Element|null} The rendered component or null if no keywords are provided
 */
const TopKeywords = ({ title, keywords: initialKeywords, className = null }) => {
  const keywords = initialKeywords || [];

  if (!keywords.length) {
    return null;
  }

  const classes = classNames(namespace, className);
  const listItems = keywords.map((keyword) => (
    <li className={`${namespace}__item`} key={keyword.label}>
      <a className={`${namespace}__link`} href={keyword.url}>
        {keyword.label}
      </a>
    </li>
  ));

  return (
    <section className={classes}>
      <ul className={`${namespace}__list`}>
        <li className={`${namespace}__item`}>{title}</li>
        {listItems}
      </ul>
    </section>
  );
};

TopKeywords.propTypes = {
  ...topKeywordsPropTypes,
};

export default withComponentHandler(TopKeywords, { componentName: 'TopKeywordsDesktop' });
